var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeIconPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0018 2.66663L19.5152 6.17996H25.8198V12.484L29.3332 15.9973L25.8198 19.516V25.82H19.5158L16.0025 29.3333L12.4838 25.82H6.17984V19.516L2.6665 15.998L6.17984 12.4846V6.17996H12.4838L16.0018 2.66663Z",
    stroke: "#AD4D34",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 11.3333C17.9997 16.6666 14.6663 17.3333 11.333 17.3333C11.333 19.9999 15.6663 22.6666 19.333 19.9999C22.9997 17.3333 20.6663 11.3333 17.9997 11.3333Z",
    stroke: "#AD4D34",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIconPrimary);
export default __webpack_public_path__ + "static/media/themeIconPrimary.54a84e53ac59209451764e754a20ac24.svg";
export { ForwardRef as ReactComponent };